import {
  PageContainer,
  Panel,
  Button,
  Box,
  Grid2 as Grid,
  AddCircleIcon,
  SearchInput,
} from '@cherre-frontend/ui';
import React, { useState, useMemo } from 'react';
import LibraryBreadcrumbs from '../../components/LibraryBreadcrumbs';
import { useLibraryModelDetails } from '../../services/dom/useLibraryModelDetails';
import LibraryCard from '../../components/LibraryCard';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import {
  ModelsLibraryRoute,
  ModelTableCreateRoute,
  ModelTableReadRoute,
  TableExtractionTemplateCreateRoute,
} from '../../routes';
import Header from '../../components/ModelsLibraryHeader';

const ModelDetails: React.FC = () => {
  const history = useHistory();
  const { modelId } = useParams<{ modelId: string }>();
  const modelDetails = useLibraryModelDetails(modelId);
  const [searchQuery, setSearchQuery] = useState('');

  const handleDataGridClick = (tableId: string) => () => {
    history.push(
      generatePath(TableExtractionTemplateCreateRoute.routeDescriptor.path, {
        modelId: modelId,
        tableId: tableId,
      })
    );
  };
  /*  const handleCityClick = () => {
    //TODO: @gaspardetienne97 implement handleCityClick
    throw new Error('Function not implemented.');
  }; */
  const handleCopyClick = (tableId: string) => () => {
    history.push(
      generatePath(ModelTableCreateRoute.routeDescriptor.path, {
        modelId: modelId,
        tableId: tableId,
      })
    );
  };

  const filteredTables = useMemo(() => {
    if (!searchQuery.trim() || !modelDetails?.targetTableDefinitions) {
      return modelDetails?.targetTableDefinitions;
    }

    // Split the search query into words and normalize them
    const searchWords = searchQuery
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);

    return modelDetails.targetTableDefinitions.filter((table) => {
      // Search by Table Name (display name or internal name)
      const displayName = (table.displayName || table.name || '').toLowerCase();
      // Check if EVERY word from the search query matches at least one field
      return searchWords.every((word) => {
        return displayName.includes(word);
      });
    });
  }, [modelDetails?.targetTableDefinitions, searchQuery]);

  return (
    <PageContainer id='ModelDetailsPage'>
      <Box display='flex' flexDirection='column' paddingY={'10px'} gap='20px'>
        <Panel id='ModelDetailsBreadcrumbs' behavior='fallback'>
          <LibraryBreadcrumbs
            modelName={modelDetails?.displayName ?? modelDetails?.name}
          />
        </Panel>
        <Panel id='ModelDetailsHeader' behavior='fallback'>
          <Header
            title={modelDetails?.displayName ?? modelDetails?.name ?? ''}
            //TODO:@gaspardetienne97 change to pass the goBack function to the header
            goBackHref={generatePath(ModelsLibraryRoute.routeDescriptor.path)}
            goBackText='Back to Data Models'
          />
        </Panel>

        <Panel id='ModelDetailsFilters' behavior='fallback'>
          <Box
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
          >
            <Box>
              <SearchInput
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder='Search'
                style={{ width: '500px' }}
                size='medium'
              />
            </Box>
            {modelDetails && (
              <Button
                variant='contained'
                endIcon={<AddCircleIcon />}
                onClick={() => {
                  history.push(
                    generatePath(ModelTableCreateRoute.routeDescriptor.path, {
                      modelId: modelDetails.uid,
                    })
                  );
                }}
              >
                Create Target Table
              </Button>
            )}
          </Box>
        </Panel>
        <Panel id='ModelDetailsContent' behavior='fallback'>
          <Grid container spacing={3}>
            {filteredTables?.map((table) => {
              return (
                <Grid key={table.name} xs={12} sm={6} md={4} lg={3}>
                  <LibraryCard
                    cardTitle={table.displayName ?? table.name}
                    cardId={table.name}
                    viewLink={generatePath(
                      ModelTableReadRoute.routeDescriptor.path,
                      { modelId, tableId: table.uid }
                    )}
                    dsp={Boolean(table.dsp)}
                    onDataGridClick={handleDataGridClick(table.uid)}
                    //onCityClick={handleCityClick}
                    onCopyClick={handleCopyClick(table.uid)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Panel>
      </Box>
    </PageContainer>
  );
};

ModelDetails.displayName = 'ModelDetails';
export default ModelDetails;
